import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles } from '@material-ui/core';
import { toast } from 'react-toastify';
import { dataService } from "../../Services/data.service";
import { TextField } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export default function Supplier(props) {

  const [supplier, setSupplier] = useState(null)
  const [suppliers, setSuppliers] = useState([])
  const [filteredSuppliers, setFilteredSuppliers] = useState([])

  const classes = useStyles();

  useEffect(() => {
    dataService.getSuppliers().then(types => {

      if (JSON.stringify(suppliers) !== JSON.stringify(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))) {
        setSuppliers(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
        setFilteredSuppliers(types.Results.sort((a, b) => new Date(b.Name) - new Date(a.Name)))
      }

      if (props.chosenValue) {
        if (JSON.stringify(supplier) !== JSON.stringify(types.Results.find(x => x.Name === props.chosenValue))) {
          setSupplier(types.Results.find(x => x.Name === props.chosenValue))
        }
      }
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
  }, [])

  const setNextStep = () => {
    validate();
  }

  const validate = () => {
    if (supplier) {
      props.SetNext();
      props.setContent(supplier.ID, supplier.Name);
    } else {
      toast.error("Pick a supplier type", { position: toast.POSITION.TOP_CENTER })
    }
  }

  const onChangeItem = (e) => {
    setSupplier(suppliers.find(x => x.ID === e.target.value))
  }

  const onChangeFilterTextPress = (e) => {
    let tempList = [...suppliers]
    tempList = tempList.filter(x => x.Name.toLowerCase().includes(e.target.value.toLowerCase()))
    setFilteredSuppliers(tempList)
    if (tempList.length === 0) {
      toast.error('There are no suppliers with that name', { position: toast.POSITION.TOP_CENTER })
  }
  }

  return (
    <div className={classes.SupplierContainer}>
      <React.Fragment>
        <div className={classes.container}>
          <div className={classes.filterField}>
            <TextField id="outlined-search" label="Filter suppliers" type="search" variant="outlined" className={classes.uiTextField} size="small" onChange={(e) => onChangeFilterTextPress(e)} />
          </div>
        </div>

        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select2"
          className={classes.typeOfContractPicker}
          value={supplier && supplier.ID}
          onChange={(e) => onChangeItem(e)}
        >
          {filteredSuppliers.map(x => {
            return (
              <MenuItem value={x.ID}>{x.Name}</MenuItem>)
          })}

        </Select>
        <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
      </React.Fragment>
    </div>
  )
}


const useStyles = makeStyles({
  container: {
    flexDirection: "row"
  },
  filterField: {
    width: "80%",
    flex: 1,
    justifyContent: 'center'
  },
  buttonContainer: {
    width: "15%",
    flex: 1,
    justifyContent: 'center'
  },
  typeOfContractPicker: {
    height: 44,
    backgroundColor: 'white',
    borderWidth: 1,
    marginBottom: 10,
    width: "100%"
  },
  SupplierContainer: {
    marginTop: "30px"
  },
  uiTextField: {
    width: "95%",
    backgroundColor: "white"
  },
});